<template>

	<div>
		<template v-for="(content, i) in componentItem.content">
			<div :key="i">
				<div v-if="typeof content !== 'object'">
					<div class="form-group">
						<label>{{ i }}</label>
						<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]" >
					</div>
					<hr>
				</div>
                <div class="form-group" v-if="i === 'hotspots'" >
                    <Repeater
                    :itemArray="componentItem.content"
                    :itemField="i"
                    :template="getContentTemplate.content.hotspots[0]"
                    :forTemplate="componentItem.template"
                    />
				</div>
                
                <div class="form-group" v-else-if="i === 'background-image'">
                    <BackgroundImage :backgroundImage="componentItem.content[i]" :forTemplate="componentItem.template" />
                </div>
			</div>
		</template>
	</div>
</template>

<script>

	import Vue from 'vue';
    import BackgroundImage from '../BackgroundImage';
    import Repeater from '../Repeater';
	import ImageUploader from '../ImageUploader.vue'

	export default {
		
		name: 'BioBubble',

		components: {
			ImageUploader,
            Repeater,
            BackgroundImage
		},		

        computed:{
            getContentTemplate() {
                if(this.componentTemplates){
                    let matchedTemplate = JSON.parse(JSON.stringify(
                        this.componentTemplates.filter(item => item.template == 'bio-bubble')[0]
                    ));
                    console.log("TEMPLATE?", matchedTemplate)
                    
                    return matchedTemplate
                }else{
                    return null
                }
            }
        },

		props: ['componentItem', 'index', 'componentTemplates']

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>